<template>
    <!-- <div class="border-orange p1 rounded-pill"> -->
        <button :type="type" @click="$emit('clicked');"
            :class="defaultClass+' '+color"
            :disabled="(processing ? true : false)">{{ text }} <i class="fas fa-plus" v-if="showAddIcon"></i> <i v-if="processing" class='fas fa-spinner fa-spin'></i>
        </button>
    <!-- </div> -->
</template>

<script>

export default {
    props: {
        processing: { default: false },
        text: { default: "Submit" },
        color: { default: "primary-button" },
        type: {default: "button"},
        showAddIcon: { default: false },
        defaultClass: { default:"btn border-0 px-5 fw-bold text-white w-100 rounded-pill f-16" }
    },
}
</script>